/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-11-14 11:43:22
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-24 14:02:51
 */
import { Button, Col, Form, Modal, notification, Row, Select, Spin, Tooltip } from 'antd'
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react'
import styles from './peddingMedicalTreatment.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import {getFeesStatusDisplay, getRecipeCategoryName, RecipeCategory} from '../../../models/recipe'
import { ThemeContext } from '../../../theme/ThemeContext'
import { EditableList } from '../../../compnents/list/EditableList'
import { Columns } from './column'
import { ExcuteDetailModal } from './recordOfExecutionModal'
import { ExcuteModal } from './ExecutionModal'
import { unwrapResult } from '@reduxjs/toolkit'
import { getBatchExecuteDetail } from './peddingMedicalTreatmentSlice'
import { PrintTemplateCategory } from '../../../models/print'
import { getPrintZXDData } from '../../treatment/editor/recipeEditorSlice'
import { PrintTemplateModal } from '../../print/PrintTemplateModal'
import { NoDataIcon } from '../../../compnents/icons/Icons'
import moment from 'moment'
import { DateTimeFormatSimples } from '../../../models/datetime'
import { selectUserId, selectUserName } from '../../../app/applicationSlice'
import { getUsersInDepartmentAsync } from '../../completion/completionSlice'
import { StationCategory } from '../../../models/user'
import { ExclamationCircleFilled } from '@ant-design/icons'
import {selectAcupdataList} from "../../../layouts/layoutSlice";

const { Option } = Select

interface RecipeListItemProps {
  loading?: boolean
  patientId?: any
  data: any
  selectTabKey?: string
  refresh?: () => void
}

export const RecipeListItem = ({
  loading,
  patientId,
  data = [],
  selectTabKey,
  refresh,
}: RecipeListItemProps): ReactElement => {

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
  }
  const [form] = Form.useForm()

  const theme = useContext(ThemeContext);

  const dispatch = useDispatch<RootDispatch>()

  const userId = useSelector(selectUserId)

  const userName = useSelector(selectUserName)

  const [treatmentId, setTreatmentId] = useState<any>()

  const [printTemplateCategory, setPrintTemplateCategory] = useState<
    PrintTemplateCategory | undefined
  >()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [recordId, setRecordId] = useState('')

  const [recipeId, setRecipeId] = useState('')

  const [recipeItemId, setRecipeItemId] = useState('')

  const [isExcuteModalVisible, setIsExcuteModalVisible] = useState(false)

  const [feesStatus, setFeesStatus] = useState<any>()

  const [singleState, setSingleState] = useState(true)

  const [printZXDData, setPrintZXDData] = useState<any>()

  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false)

  const [medicalStationList, setMedicalStationList] = useState<any[]>([])

  const [assistantList, setAssistantList] = useState<any>()

  const acupointList = useSelector(selectAcupdataList)

  const getReciptPrintList = (recipeId?: any) => {
    dispatch(getPrintZXDData(recipeId))
      .then(unwrapResult)
      .then((v: any) => {
        setPrintZXDData(v)
      })
  }

  const getZXRList = () => {
    dispatch(
      getUsersInDepartmentAsync({
        departmentId: '',
        stationCategory: StationCategory.DoctorOrPharmacist,
        multyStationCategory: '0,1,7',
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setAssistantList(res)
        const operatorId = res?.find((v: any) => v?.id == userId.toString())?.id ? [userId.toString()] : []
        form.setFieldsValue({
          operatorId: operatorId,
        })
      })
  }

  useEffect(() => {
    if(isConfirmModalVisible) {
      getZXRList()
    }
  }, [isConfirmModalVisible])



  return (
    <>
      <Spin spinning={loading} style={{ paddingTop: '100px' }}>
        {data?.length ? data?.map((v: any, index: number) => {
          return <div
            key={index}
            className={styles.recipelistItemMain}
          >
            <Row className={styles.recipelistItemTitleRow}
              style={{
                backgroundColor: theme.th,
              }}>
              <Col span={12}>
                <span style={{ fontWeight: 'bold' }}>{getRecipeCategoryName(v.category)}</span>，处方编号：
                  {v.recipeId} <span style={{ color: getFeesStatusDisplay(v?.feesStatus).color, marginLeft: '6px'}}>{getFeesStatusDisplay(v?.feesStatus).text}</span>
              </Col>
              <Col span={12} className={styles.recipelistItemTitleButton}>
                {/* selectTabKey == 1 已执行  或 feesStatus == 5 已退费  */}
                {selectTabKey == '1' || v?.feesStatus=='5' ? '' : <>
                  <Button
                    type="primary"
                    ghost
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      setIsConfirmModalVisible(true)
                      setMedicalStationList(v?.medicalStationList || [])
                    }}>全部执行</Button>
                  <Button
                    type="primary"
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      setIsExcuteModalVisible(true)
                      setSingleState(false)
                      setRecipeId(v.recipeId)
                    }}
                  >批量执行</Button>
                </>}
                <Button
                  type="primary"
                  onClick={() => {
                    if (v?.recipeId) {
                      setRecipeId(v?.recipeId)
                      setTreatmentId(v?.treatmentId)
                      getReciptPrintList(v?.recipeId)
                      setPrintTemplateCategory(PrintTemplateCategory.Zxd)
                    }
                  }
                  }>打印
                </Button>
              </Col>
            </Row>
            <EditableList
              bordered
              pagination={false}
              page={{
                items: v?.medicalStationList || [],
                current: 1,
                size: 10,
                total: 0,
              }}
              columns={Columns((text, t) => {
                if (text == 'execute') {
                  setIsExcuteModalVisible(true)
                  setRecipeItemId(t.recipeItemId)
                  setRecipeId(v.recipeId)
                  setSingleState(true)
                } else if (text == 'record') {
                  setIsModalVisible(true)
                  setRecordId(t?.id)
                  setFeesStatus(v?.feesStatus)
                }
              }, selectTabKey,v?.feesStatus,acupointList,v?.category)}
            />

          </div>
        }) : <div className={styles.noPageData}>
          <NoDataIcon
            style={{
              width: 200,
              height: 200,
              opacity: 0.5,
            }}
          />
          <span>暂无数据</span>

        </div>}
      </Spin>
      {/* 记录 */}
      <ExcuteDetailModal
        id={recordId}
        feesStatus={feesStatus}
        isModalVisible={isModalVisible}
        onOk={(() => {
          setIsModalVisible(false)
        })}
        onCancel={(() => {
          setIsModalVisible(false)
          refresh && refresh()
        })}
      />

      {/* 执行 */}
      <ExcuteModal
        singleState={singleState}
        recipeId={recipeId}
        recipeItemId={recipeItemId}
        isModalVisible={isExcuteModalVisible}
        onOk={(() => {
          setIsExcuteModalVisible(false)
          setRecordId('')
          refresh && refresh()
        })}
        onCancel={(() => {
          setIsExcuteModalVisible(false)
          setRecordId('')
        })}
        acupointList={acupointList}
      />
      <PrintTemplateModal
        patientId={patientId}
        printZXDData={printZXDData}
        pagePrintFlag={'zxdPrint'}
        visible={!!printTemplateCategory}
        templateCategory={printTemplateCategory}
        recipeId={recipeId}
        treatmentId={treatmentId}
        onCancel={() => setPrintTemplateCategory(undefined)}
        onOk={() => setPrintTemplateCategory(undefined)}
      />
      <Modal
        destroyOnClose
        title='全部执行'
        visible={isConfirmModalVisible}
        onOk={(() => {
          form.submit()
        })}
        onCancel={(() => {
          setIsConfirmModalVisible(false)
          setMedicalStationList([])
          form.resetFields()
        })}>
        <div style={{ marginBottom: '20px', display: 'flex', }}>
          <div><ExclamationCircleFilled style={{ color: '#FFAE55', fontSize: 20, marginRight: '10px' }} /></div>
          <div>全部执行后，当前处方单里的所有项目执行进度全部完成，请确认是否要全部执行？</div>
        </div>
        <Form
          form={form}
          onFinish={(values) => {
            const data = assistantList.filter((item: any) =>
              values.operatorId.includes(item.id)
            )
            const operatorName = data.map((item: any) => item.name)
            const params: any = medicalStationList?.map((item: any) => ({
              ...item,
              executeAll: true,
              executeTime: item?.executeTime ? moment(item?.executeTime).format(DateTimeFormatSimples) : moment().format(DateTimeFormatSimples),
              operatorId: values?.operatorId?.length
                ? values?.operatorId?.join(',')
                : '',
              operatorName: operatorName?.length
                ? operatorName?.join(',')
                : '',
            }))
            dispatch(getBatchExecuteDetail(
              params
            ))
              .then(unwrapResult)
              .then((v) => {
                notification.success({
                  message: '操作成功',
                })
                refresh && refresh()
              })
              .finally(() => {
                setMedicalStationList([])
                form.resetFields()
                setIsConfirmModalVisible(false)
              })
          }}>
          <Form.Item
            {...layout}
            name='operatorId'
            label='执行人：'
            rules={[{ required: true, message: '请选择执行人' }]}
          >
            <Select
              mode='multiple'
              placeholder='执行人'
              allowClear
            >
              {assistantList?.map((v: any) => (
                <Option key={v.id?.toString()} value={v.id?.toString()}>
                  {v.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
